module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product12-f53d75b3877ab668a375cc5762e866e0.jpg";